export default __webpack_public_path__ + "static/media/card1600.419b46a8.jpg";